import React from "react";

const styles = {
  default: "border-t-2 border-indigo-500",
  approved: "border-t-2 border-green-500",
  failed: "border-t-2 border-red-500"
};

const InfoContainer = ({ signatureIsValid, children }) => {
  const [status, setStatus] = React.useState("default");

  React.useEffect(() => {
    switch (signatureIsValid) {
      case true:
        setStatus("approved");
        break;
      case false:
        setStatus("failed");
        break;
      default:
        setStatus("default");
        break;
    }
  }, [signatureIsValid]);

  return (
    <div
      className={`bg-white items-center content-center pt-5 pb-5 flex flex-col justify-center align-middle ${styles[status]}`}
    >
      {children}
    </div>
  );
};

export default InfoContainer;
